import React from "react";
import { NavLink } from "react-router-dom";
import { alpha, ListItem, ListItemAvatar, ListItemText } from "@mui/material";

const MenuItem = ({ disabled, icon, text, link, onClick, end = false }) => {
  return (
    <ListItem
      component={link ? NavLink : 'button'}
      to={link}
      type={link ? undefined : 'button'}
      onClick={onClick}
      disabled={disabled}
      end={end}
      sx={(theme) => ({
        borderLeft: "6px solid transparent",
        paddingRight: 2,
        ...(!link && {
          borderTop: 0,
          borderRight: 0,
          borderBottom: 0,
          background: 'transparent',
          textAlign: 'left',
          cursor: 'pointer',
          '&:hover': { backgroundColor: theme.palette.action.hover },
        }),
        "&.active": {
          borderLeft: `6px solid ${theme.palette.secondary.main}`,
          background: alpha(theme.palette.secondary.main, 0.15),
        },
      })}
    >
      <ListItemAvatar>{icon}</ListItemAvatar>
      <ListItemText
        primary={text}
        primaryTypographyProps={{ sx: { color: 'black' } }}
      />
    </ListItem>
  );
};

export default MenuItem;
